const rankingItems = [
  { rank: 1, title: '星际征途：新纪元', type: '科幻 / 动作', hot: '🔥 986万播放', change: 'up', isNew: true },
  { rank: 2, title: '暗夜追踪', type: '悬疑 / 犯罪', hot: '🔥 753万播放', change: 'up', isNew: false },
  { rank: 3, title: '时光旅人', type: '剧情 / 奇幻', hot: '⭐ 9.1分', change: 'same', isNew: false },
  { rank: 4, title: '梦境奇缘', type: '动画 / 冒险', hot: '🔥 621万播放', change: 'up', isNew: true },
  { rank: 5, title: '霸王别姬 (重制)', type: '剧情 / 历史', hot: '⭐ 9.6分', change: 'down', isNew: false },
  { rank: 6, title: '极速狂飙', type: '动作 / 赛车', hot: '🔥 498万播放', change: 'up', isNew: true },
];

function ChangeIcon({ change }: { change: string }) {
  if (change === 'up') return <i className="ri-arrow-up-line text-green-500 text-sm"></i>;
  if (change === 'down') return <i className="ri-arrow-down-line text-red-400 text-sm"></i>;
  return <span className="text-foreground-300 text-sm">—</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-trophy-line mr-1"></i>TOP 排行榜
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热播榜单</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">本周最热影片排行，看看大家都在看什么</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-4 py-4 border-b border-secondary-100 last:border-b-0 cursor-pointer hover:bg-background-100 transition-colors rounded-lg group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-secondary-300 text-white' :
                item.rank === 3 ? 'bg-secondary-200 text-secondary-700' :
                'bg-secondary-100 text-secondary-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  {item.isNew && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-600 whitespace-nowrap">NEW</span>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-semibold text-foreground-800">{item.hot}</p>
                <div className="flex items-center justify-end gap-1 mt-0.5">
                  <ChangeIcon change={item.change} />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <button className="px-6 py-2.5 bg-secondary-100 hover:bg-secondary-200 text-foreground-700 text-sm font-medium rounded-lg whitespace-nowrap cursor-pointer transition-colors">
            查看完整榜单 <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}